import gql from 'graphql-tag';

export default gql`
query NOTIFICATIONS($after: String, $companyKsuid: String!) {
  unreadNotifications: companyInAppNotifications(
    after: $after
    first: 30
    companyKsuid: $companyKsuid
    isRead: false
  ) {
    count
  }
  companyInAppNotifications(
    after: $after
    first: 30
    companyKsuid: $companyKsuid
  ) {
    count
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ksuid
        notificationTime
        actionCode
        enNotificationContent
        idNotificationContent
        actionPayload
        idNotificationContent
        isRead
      }
    }
  }
}
`;
